import { FieldClassification } from "../enums/FieldClassifications";

export default function fieldFollowsThirdPartyRules(fieldClassification, isThirdParty) {
    // This logic may need to be updated, since IsThirdParty is supposed to only apply to folders now
    if (
        fieldClassification == FieldClassification.ThirdParty ||
        fieldClassification == FieldClassification.PrivateThirdParty ||
        isThirdParty
    ) {
        return true;
    }

    return false;
}

export function containsThirdPartyFields(fields) {
    let thirdPartyFields = [];

    if (fields) {
        thirdPartyFields = fields.filter(
            // Ignore the IsThirdParty property; rely solely on FieldClassification
            x =>
                x.FieldClassification == FieldClassification.ThirdParty ||
                x.FieldClassification == FieldClassification.PrivateThirdParty
        );
    }

    return thirdPartyFields.length > 0;
}
